import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const directPutawayRolesRBAC = {
  pageID: 'b30bef249e1c5283f8c9ad93bce1bd1b',
  elementID: {
    ViewPutawayList: 'bed3add0f53802b380e247211a925849',
  },
} as const

export const useRBACDirectPutawayPage = createUseRBAC(directPutawayRolesRBAC.elementID)

export type UseRBACDirectPutawayPageType = ReturnType<typeof useRBACDirectPutawayPage>
